import { render, staticRenderFns } from "./ActionPhoneDetailOverlay.vue?vue&type=template&id=94418d12&scoped=true&"
import script from "./ActionPhoneDetailOverlay.vue?vue&type=script&lang=ts&"
export * from "./ActionPhoneDetailOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./ActionPhoneDetailOverlay.vue?vue&type=style&index=0&id=94418d12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94418d12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94418d12')) {
      api.createRecord('94418d12', component.options)
    } else {
      api.reload('94418d12', component.options)
    }
    module.hot.accept("./ActionPhoneDetailOverlay.vue?vue&type=template&id=94418d12&scoped=true&", function () {
      api.rerender('94418d12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ActionPhoneDetailOverlay.vue"
export default component.exports